const gql = {
  query: `mutation AddBank($input: AdvBankRequestInput!) {
        addBank(input: $input){
          success
          data{
            bankVerificationResult
            errors{
              errorCode
              errorMessage
            }
          }
        }
    }`,
  variables: {
    input: {
      bankAccount: null,
    },
  },
  meta: {
    label: "Add Bank",
  },
};

export default gql;
